import React, { useCallback } from 'react';
import { Button, LinearProgress } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { ConfirmActionCallBackType, ConfirmationDialogProps } from './ConfirmationDialog.props';
import Dialog from '../Dialog';
import { Actions, Content, ContentSpaced } from './ConfirmationDialog.styles';

const ConfirmationDialog = ({
  open,
  title,
  maxWidth = 'sm',
  children,
  onClose,
  actions,
  isLoading,
}: ConfirmationDialogProps) => {
  const confirmAction = useCallback(
    async (callback?: ConfirmActionCallBackType) => {
      if (callback) {
        await callback();
      }
      onClose();
    },
    [onClose]
  );

  const ContentComponent = maxWidth !== 'xs' ? ContentSpaced : Content;

  return (
    <Dialog title={title ?? 'Confirmation'} maxWidth={maxWidth} fullWidth onClose={onClose} open={open}>
      {isLoading && <LinearProgress color="primary" />}
      <ContentComponent>{children}</ContentComponent>
      <Actions>
        {actions?.map(action => {
          let sx = {};
          if (action.type === 'success') {
            sx = {
              color: (theme: Theme) => theme.palette.error.contrastText,
              backgroundColor: (theme: Theme) => theme.palette.secondary.main,
              '&:hover': {
                backgroundColor: (theme: Theme) => theme.palette.secondary.dark,
              },
            };
          } else if (action.type === 'danger') {
            sx = {
              color: (theme: Theme) => theme.palette.error.contrastText,
              backgroundColor: (theme: Theme) => theme.palette.error.light,
              '&:hover': {
                backgroundColor: (theme: Theme) => theme.palette.error.dark,
              },
            };
          }
          return (
            <Button
              key={action.label}
              variant={action.variant}
              disabled={action.disabled}
              color="primary"
              sx={sx}
              onClick={() => (action.callback ? confirmAction(action.callback) : onClose())}>
              <span>{action.label}</span>
            </Button>
          );
        })}
      </Actions>
    </Dialog>
  );
};

export default ConfirmationDialog;
